import React, { createContext, useContext, useState, type ReactNode } from 'react'

type CustomRangeContextValue = {
  inputValue: { from: string; to: string }
  setInputValue: React.Dispatch<React.SetStateAction<{ from: string; to: string }>>
  lastAppliedInputValue: { from: string; to: string }
  setLastAppliedInputValue: React.Dispatch<React.SetStateAction<{ from: string; to: string }>>
  chartValue: { from: string; to: string }
  setChartValue: React.Dispatch<React.SetStateAction<{ from: string; to: string }>>
}

type CustomRangeProviderProps = {
  children: ReactNode
}

const CustomRangeContext = createContext<CustomRangeContextValue | null>(null)

const CustomRangeProvider: React.FC<CustomRangeProviderProps> = ({ children }) => {
  const [inputValue, setInputValue] = useState({ from: '', to: '' })
  const [lastAppliedInputValue, setLastAppliedInputValue] = useState({ from: '', to: '' })
  const [chartValue, setChartValue] = useState({ from: '', to: '' })

  return (
    <CustomRangeContext.Provider
      value={{ inputValue, setInputValue, chartValue, setChartValue, lastAppliedInputValue, setLastAppliedInputValue }}
    >
      {children}
    </CustomRangeContext.Provider>
  )
}

export const useCustomRange = (): CustomRangeContextValue => {
  const context = useContext(CustomRangeContext)

  if (!context) {
    throw new Error('useCustomRange must be used within a CustomRangeProvider')
  }

  return context
}

export { CustomRangeProvider }
